export const classNameMapper = (map: Record<string, boolean>, addtlClasses?: string): string => {
  return (
    Object.entries(map)
      .filter(([_, filter]) => filter)
      .reduce((acc, curr) => acc + (acc.length ? " " : "") + curr[0], "") + (addtlClasses ? " " + addtlClasses : "")
  );
};
